@if (vm$ | async; as vm) {
<atx-modal-header
  (dismiss)="close()"
  showCloseBtn="true"
  i18n="VMI|VMI/DDR modal modal header text@@vmiModalModalHeaderText"
>
  VMI/DDR
</atx-modal-header>

<atx-modal-body>
  <p i18n="VMI|VMI/DDR modal title text@@vmiDdrModalTitle">
    Download VMI/DDR list for your store
  </p>
  <button
    atxDropdown
    class="btn btn-block btn-light d-inline-flex align-items-center justify-content-between"
    [atxDropdownMenu]="menu"
    data-e2e="sort-dropdown-menu-btn"
  >
    @if (vm.selected) {
    <span>{{ vm.selected.displayName }}</span>
    } @else {
    <span i18n="VMI|VMI/DDR modal dropdown text@@vmiDdrModalDropdownText"
      >Select Brand</span
    >
    }

    <fa-layers>
      <fa-icon
        [icon]="['fas', 'angle-up']"
        size="xs"
        transform="up-6"
      ></fa-icon>
      <fa-icon
        [icon]="['fas', 'angle-down']"
        size="xs"
        transform="down-6"
      ></fa-icon>
    </fa-layers>
  </button>
  <atx-dropdown-menu #menu="atxDropdownMenu">
    @for (brand of vm.brands; track brand.id) {
    <atx-dropdown-item
      [active]="vm.selected?.displayName === brand.displayName"
      (click)="selectBrand(brand)"
    >
      {{ brand.displayName }}
    </atx-dropdown-item>
    }
  </atx-dropdown-menu>
</atx-modal-body>

<atx-modal-footer>
  <button
    class="btn btn-light mr-3"
    i18n="VMI|VMI/DDR modal cancel button@@vmiDdrModalCancelButton"
    [disabled]="vm.downloading"
    (click)="close()"
  >
    Cancel
  </button>

  <div
    atxTooltip="You should select the brand first"
    i18n-atxTooltip="
      VMI|Download disabled button tooltip text@@vmiDownloadDisabledTooltip"
    [tooltipEnabled]="!vm.selected"
  >
    <button
      class="btn btn-primary"
      [disabled]="!vm.selected || vm.downloading"
      (click)="confirm()"
    >
      @if (vm.downloading) {
      <fa-icon
        [icon]="['fas', 'spinner']"
        animation="spin-pulse"
        class="mr-1"
      ></fa-icon>
      <span
        i18n="
          VMI|VMI/DDR modal downloading button@@vmiDdrModalDownloadingButton"
      >
        Downloading
      </span>
      } @else {
      <span i18n="VMI|VMI/DDR modal download button@@vmiDdrModalDownloadButton">
        Download
      </span>
      }
    </button>
  </div>
</atx-modal-footer>
}
